<template>
    <div class="foot">
        <div class="pc" data-aos="fade-down" data-aos-duration="500" data-aos-delay="0">
            <div class="menu">
                <div class="menu_item" v-for="(item, index) in nav" :key="index">
                    <div v-if="item.subtitle.length > 0" class="menu_title">{{item.title[lang]}}</div>
                    <div v-if="item.subtitle.length === 0" class="menu_title menu_title_click" @click="toPage(item.url)">{{item.title[lang]}}</div>
                    <div class="sub_menu">
                        <router-link :to="subitem.url" style="text-decoration: none;" v-for="(subitem, subindex) in item.subtitle" :key="subindex">
                            <div class="subtitle" >
                                {{subitem.title[lang]}}
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="logo_box">
                <router-link to='/'>
                    <img class="logo" src="../assets/images/deansel_logo.png" alt="">
                </router-link>
                <div class="info_box">
                    <div class="info_item">
                        <div class="info_icon">
                            <img class="img_base" src="../assets/images/mail.png" alt="">
                        </div>
                        <a class="info" href="mailto:info@deansel.com">info@deansel.com</a>
                    </div>
                    <div class="info_item">
                        <div class="info_icon">
                            <img class="img_base" src="../assets/images/addr.png" alt="">
                        </div>
                        <div class="info">{{lang === 0 ? '上海市黄浦区黄陂南路380号新天地新里7楼' : 'Room 201, building 3, No 18. Jinhai Road, Pudong, Shanghai'}}</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div>{{lang === 0 ? 'Copyright © 2017 Inc. 保留所有权利。© 上海鼎栈信息科技有限公司' : 'Copyright © 2017 Inc. All rightl reserved by © Deansel Co., Ltd'}}</div>
                <a style="text-decoration: none; color: #000;" href="https://beian.miit.gov.cn">沪ICP备17016135号-1</a>
            </div>
        </div>
        <div class="mobile" data-aos="fade-down" data-aos-duration="500" data-aos-delay="0">
            <div class="top">
                <div class="logo_box">
                    <router-link to='/'>
                        <img class="logo" src="../assets/images/deansel_logo.png" alt="">
                    </router-link>
                    <div class="line"></div>
                    <div class="info_box">
                        <div class="info_item">
                            <div class="info_icon">
                                <img class="img_base" src="../assets/images/mail.png" alt="">
                            </div>
                            <a class="info" href="mailto:info@deansel.com">info@deansel.com</a>
                        </div>
                        <div class="info_item">
                            <div class="info_icon">
                                <img class="img_base" src="../assets/images/addr.png" alt="">
                            </div>
                            <div class="info">{{lang === 0 ? '上海市浦东新区金海路18号天物空间2期3号楼201' : 'Room 201, building 3, No 18. Jinhai Road, Pudong, Shanghai'}}</div>
                        </div>
                    </div>
                </div>
                <div class="sidenavBox">
                    <div class="sidenav_item" v-for="(item, index) in nav" :key="index">
                        <div v-if="item.subtitle.length > 0" class="sidenav_item_title" @click="changNavState(index)">
                            <div>{{item.title[lang]}}</div>
                            <div :class="currentIndex === index ? 'drop-up' : 'drop-down'"></div>
                        </div>
                        <div v-if="item.subtitle.length === 0" class="sidenav_item_title sidenav_item_title_click" @click="toPage(item.url)">
                            <div>{{item.title[lang]}}</div>
                        </div>
                        <transition name="slide">
                            <div class="sub_sidenav" v-show="currentIndex === index">
                                <router-link :to="subitem.url" style="text-decoration: none;" v-for="(subitem, subindex) in item.subtitle" :key="subindex">
                                    <div class="side_subtitle" >
                                        {{subitem.title[lang]}}
                                    </div>
                                </router-link>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div>{{lang === 0 ? 'Copyright © 2017 Inc. 保留所有权利。© 上海鼎栈信息科技有限公司' : 'Copyright © 2017 Inc. All rightl reserved by © Deansel Co., Ltd'}}</div>
                <a style="text-decoration: none; color: #000;" href="https://beian.miit.gov.cn">沪ICP备17016135号-1</a>
            </div>
        </div>
    </div>
    
</template>

<script>
import {navText} from '@/js/text.js'
export default {
    data () {
        return {
            nav: navText,
            currentIndex: null
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        }
    },
    methods: {
        toPage (url) {
            if (this.$route.path !== url) {
                this.$router.push({path: url})
            }
        },
        changNavState (index) {
            this.currentIndex = this.currentIndex === index ? null : index
        }
    }
}
</script>

<style scoped>
.pc {
    width: 80%;
    margin: 10% 10% 5% 10%;
    border-top: solid #a1a1a1 1px;
}
.menu {
    margin: 5% auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.menu_item {
    font-size: 0.75rem;
}
.menu_title {
    font-weight: bold;
    margin-bottom: 20px;
}
.menu_title_click:hover {
    cursor: pointer;
    text-decoration: underline;
}
.sub_menu {
    display: flex;
    flex-direction: column;
}
.subtitle {
    margin-bottom: 10px;
    color: #000;
}
.subtitle:hover {
    text-decoration: underline;
}
.logo_box {
    width: 50vw;
    border-top: solid #d8d8d8 1px;
    margin: 5% auto 3% auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3% 0;
}
.logo {
    width: 8vw;
    margin-right: 4vw;
}
.info_item {
    /* width: 38vw; */
    display: flex;
    align-items: center;
    text-align: left;
}
.info_item:nth-child(1) {
    margin-bottom: 2vw;
}
.info_icon {
    width: 16px;
    height: 16px;
    margin-right: 1vw;
}
.info {
    text-decoration: none;
    color: #000;
    font-size: 0.75rem;
    width: 27vw;
    /* max-height: 1.5rem; */
    /* line-height: 1.5rem; */
}
.bottom {
    font-size: 0.75rem;
    line-height: 1.5;
    margin: 0 auto;
}
.mobile {
    display: none;
    width: 80%;
    margin: 10% 10% 5% 10%;
    border-top: solid #a1a1a1 1px;
}
.top {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.top .logo_box {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 40vw;
    border: none;
    padding: 0;
    margin: 10% auto;
}
.top .logo {
    width: 26vw;
}
.top .line {
    margin: 2vw 0;
    width: 26vw;
    border-top: solid #d8d8d8 1px;
}
.top .info_item {
    justify-content: flex-start;
    margin-bottom: 10px;
}
.sidenavBox {
    font-size: 0.75rem;
    color: #000;
    width: 130px;
    text-align: center;
    line-height: 2;
    text-align: left;
    margin: 10% auto;
}
.sidenav_item {
    padding: 10px auto;
    box-sizing: border-box;
    /* border-bottom: #d8d8d8 solid 1px; */
}
.sidenav_item:nth-last-child(1) {
    border: none;
}
.sidenav_item_title {
    font-weight: bold;
    position: relative;
    line-height: 3;
}
.sidenav_item_title_click:hover {
    cursor: pointer;
}
.drop-down {
    width: 6px;
    height: 6px;
    position: absolute;
    right: 0;
    top: 12px;
    border:#000 solid;
    border-width: 1px 1px 0 0;
    transform: rotate(135deg);
}
.drop-up {
    width: 6px;
    height: 6px;
    position: absolute;
    right: 0;
    top: 16px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}
.sub_sidenav {
    margin-bottom: 10px;
    transform-origin: top center;
}
.side_subtitle {
    color: #000;
    margin: 10px auto;
    line-height: 1.2;
}
.slide-enter-active {
  transition: all .3s ease;
}
.slide-leave-active {
    transition: all 0s ease;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scaleY(0);
}
@media screen and (max-width: 756px) {
    .pc {
        display: none;
    }
    .mobile {
        display: block;
    }
}
</style>
